export const otherSubtopicId = Number(process.env.VUE_APP_OTHER_SUBTOPIC_ID)
